// helper.js
// { day: 1-31, offset:-1|0|1 }  offset: 이전달 -1 / 이번달 0 / 다음달 1
export function getCalendar(year, month) {
    const prevDays   = new Date(year, month, 0).getDate();
    const daysInMon  = new Date(year, month + 1, 0).getDate();
    const firstDow   = new Date(year, month, 1).getDay();
    const weeks = [];
    let week  = [];
  
    /* ① 앞 달 채우기 */
    for (let i = firstDow - 1; i >= 0; i--) {
      week.push({ day: prevDays - i, offset: -1 });
    }
  
    /* ② 이번 달 */
    for (let d = 1; d <= daysInMon; d++) {
      week.push({ day: d, offset: 0 });
      if (week.length === 7) { weeks.push(week); week = []; }
    }
  
    /* ③ 다음 달 채우기 */
    let nextDay = 1;
    if (week.length) {
      while (week.length < 7) week.push({ day: nextDay++, offset: 1 });
      weeks.push(week);
    }
    return weeks;
   }